<template>
  <div style="padding:80px">
    <Form :model="formData" ref="formDataR"
      :rules="ruleValidate"
      :label-width="150"
      @submit.native.prevent="save"
    >
      <FormItem label="账号" prop="name">
        <Input v-model="formData.name" />
      </FormItem>
      <FormItem label="姓名" prop="real_name">
        <Input v-model="formData.real_name" />
      </FormItem>
      <Row>
        <FormItem label="手机号" prop="mobile" style="width:40%;margin-right:1vw">
        <Input
          type="number"
          v-model="formData.mobile"
          maxlength="11"
        />
        </FormItem>
        <FormItem prop="code" style="width:24%;margin:0 20px 0 -150px">
         <Input v-model="formData.code" placeholder="输入验证码"  style="width:100%;margin-right:1vw"/>
      </FormItem>
      <Button type="primary" @click="getCode"
          >获取验证码</Button
        >
        <span v-show="!show">{{ count }} s</span>
      </Row>
      
      <FormItem label="登录密码" prop="password">
        <Input type="password" v-model="formData.password"/>
      </FormItem>
       <FormItem label="邮箱">
        <Input v-model="formData.email" />
      </FormItem>
      <FormItem label="省" prop="province_id">
        <Select
          v-model="formData.province_id"
          filterable
          @on-change="provinceIdChange"
        >
          <Option
            v-for="option in provinceArr"
            :key="option.id"
            :value="option.id"
            >{{ option.name }}</Option
          >
        </Select>
      </FormItem>
      <FormItem label="市" prop="city_id">
        <Select v-model="formData.city_id" filterable @on-change="cityIdChange">
          <Option
            v-for="option in cityArr"
            :key="option.id"
            :value="option.id"
            >{{ option.name }}</Option
          >
        </Select>
      </FormItem>
      <FormItem label="区县" prop="area_id">
        <Select v-model="formData.area_id">
          <Option
            v-for="option in districtArr"
            filterable
            :key="option.id"
            :value="option.id"
            >{{ option.name }}</Option
          >
        </Select>
      </FormItem>
      <FormItem label="选择学校" prop="campus_id">
        <Select
          v-model="formData.campus_id"
          filterable 
        >
          <Option
            v-for="option in campusArr"
            :key="option.id"
            :value="option.id"
            >{{ option.name }}</Option
          >
        </Select>
      </FormItem>
      <FormItem label="选择级别" prop="grade_ids">
        <Select
          v-model="grade_ids"
          filterable multiple @on-change='gradechange'
        >
          <Option
            v-for="option in gradeArr"
            :key="option.id"
            :value="option.id"
            >{{ option.name }}</Option
          >
        </Select>
      </FormItem>
      <FormItem label="选择科目" prop="subject_ids">
        <Select
          v-model="subject_ids"
          filterable multiple @on-change='subjchange'
        >
          <Option
            v-for="option in subjectArr"
            :key="option.id"
            :value="option.id"
            >{{ option.name }}</Option
          >
        </Select>
      </FormItem>
      <FormItem label="选择课程" prop="curse_ids">
        <Select
          v-model="curse_ids"
          filterable multiple
        >
          <Option
            v-for="option in curseArr"
            :key="option.id"
            :value="option.id"
            >{{ option.name }}</Option
          >
        </Select>
      </FormItem>
      <FormItem style="text-align: right">
        <Button type="info" @click="$router.replace({ name: 'Login'})"
          >返回</Button
        >&nbsp;&nbsp;
        <Button type="primary" html-type="submit" :loading="formLoading"
          >注册</Button
        >
      </FormItem>
    </Form>
  </div>
</template>
<script>
import addPage from "../../src/mixins/addPage";
export default {
  data() {
    const validatesubject = (rule, value, callback) => {
      //  if (!this.subject_ids||this.subject_ids.length==0) {
      //     callback(new Error('请选择科目'));
      // }
      this.formData.subject_ids=this.subject_ids.join(',')
      // if (this.subject_ids) {
      //   callback();
      // }
    };
     const validatecurse = (rule, value, callback) => {
      //  if (!this.curse_ids||this.curse_ids.length==0) {
      //     callback(new Error('请选择课程'));
      // }
      this.formData.curse_ids=this.curse_ids.join(',')
      // if (this.curse_ids) {
      //   callback();
      // }
    };
    const validategrade = (rule, value, callback) => {
      //  if (!this.grade_ids||this.grade_ids.length==0) {
      //     callback(new Error('请选择级别'));
      // }
      this.formData.grade_ids=this.grade_ids.join(',')
      // if (this.grade_ids) {
      //   callback();
      // }
    };
    return {
      formData: {
        name: "",
        province_id: "",
        city_id: "",
        area_id: "",
        is_display: 2,
        content: "",
      },
      show: true,
      count: null,
      grade_ids:[],
      curse_ids:[],
      subject_ids:[],
      curseArr: [], //任教课程
      subjectArr: [], //科目
      gradeArr: [], //级别
      campusArr: [],
      ruleValidate: {
        name: [{ required: true, message: "请填写账号", trigger: "blur" }],
        real_name: [{ required: true, message: "请填写姓名", trigger: "blur" }],
        code: [
          { required: true, message: "请填写验证码", trigger: "blur" },
          {
            type: "string",
            pattern: /^\d{4}$/,
            message: "验证码格式有误",
            trigger: "blur",
          },
        ],
        mobile: [
          { required: true, message: "请填写手机号", trigger: "blur" },
          {
            type: "string",
            pattern: /^1[3456789]\d{9}$/,
            message: "手机号格式有误",
            trigger: "blur",
          },
        ],
        email: [
          { required: true, message: "请填写邮箱", trigger: "blur" },
          {
            type: "string",
            pattern: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/,
            message: "邮箱格式有误",
            trigger: "blur",
          },
        ],
        subject_ids: [
          { required: false, message: "请选择科目", trigger: "blur",validator: validatesubject },
        ],
        curse_ids: [
          { required: false, message: "请选择课程", trigger: "blur",validator: validatecurse },
        ],
        grade_ids: [
          { required: false, message: "请选择级别", trigger: "blur",validator: validategrade },
        ],
        password: [
          { required: true, message: "请输入登录密码", trigger: "blur" },
        ],
        campus_id: [{ required: true, message: "请选择学校" }],
        area_id: [{ required: true, message: "请选择区县" }],
        city_id: [{ required: true, message: "请选择市" }],
        province_id: [{ required: true, message: "请选择省" }],
      },
      formLoading: false,
    };
  },
  mixins: [addPage],
  created() {},
  mounted() {
    this.getcampus()
    this.getsubject();
    this.getgrades();
    this.curseArr = [];
    this.curse_ids=[]
    // this.getcurse();
  },
  methods: {
    provinceIdChange(e) {
      this.prov = e;
    },
    cityIdChange(e) {
      this.city = e;
    },
    getcampus() {
      this.campusArr = [];
      this.$axios.post("/app/auth/getCampus").then((res) => {
        if (res.code == 1) {
          this.campusArr = res.data;
        } else {
          this.$Message.error(res.msg);
        }
      });
    },
    gradechange(e){
      this.getcurse()
    },
    subjchange(e){
      this.getcurse()
    },
    getgrades() {
      //获取级别
      this.gradeArr = [];
      this.$axios.post("/app/auth/getGrade").then((res) => {
        if (res.code == 1) {
          this.gradeArr = res.data;
        } else {
          this.$Message.error(res.msg);
        }
      });
    },
    save() {
      console.log(22)
        this.$refs.formDataR.validate((valid) => {
          console.log(233344)
          // this.formLoading = true;
            if (valid) {
                this.$axios.post('/app/auth/register', this.formData).then(res => {
                    this.formLoading = false;
                    if (res.code==1) {
                        this.$Message.success('注册成功');
                        this.$router.replace({ name: "Login" });
                    } else {
                        this.$Message.error(res.msg);
                    }
                });
            } else {
                this.$Message.error('请先完善信息');
                this.formLoading = false;
            }
        })
    },
    getsubject() {
      //获取科目
      this.subjectArr = [];
      this.$axios.post("/app/auth/getSubject").then((res) => {
        if (res.code == 1) {
          this.subjectArr = res.data;
        } else {
          this.$Message.error(res.msg);
        }
      });
    },
    getcurse() {
      //任教课程
     if(!this.grade_ids||!this.subject_ids){
        return false
      }
      this.curseArr = [];
      this.curse_ids=[]
      this.$axios.post("/app/auth/getCourse?subject_id="+this.subject_ids
      +'&grade_id='+this.grade_ids
      ).then((res) => {
        if (res.code == 1) {
          this.curseArr = res.data;
        } else {
          this.$Message.error(res.msg);
        }
      });
    },
    getCode() {
      if (this.formData.mobile != "") {
        // 1.首先判断是否未输入手机号码就点击获取验证码
        if (/^1[34578]\d{9}$/.test(this.formData.mobile)) {
          //2.使用正则判断手机输入的验证码是否符合规范
          const TIME_COUNT = 60; // 3.设置时间为60s
          if (!this.timer) {
            this.count = TIME_COUNT;
            this.show = false; // 4.隐藏获取验证码按钮,展示倒计时模块
            this.getPhoneCode(); // 5.调用后端获取验证码接口的函数
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                // 6.设置每秒钟递减
                this.count--;
              } else {
                // 7.递减至0时,显示获取验证码按钮,隐藏倒计时模块,清除定时器this.timer,并将其置为null
                this.show = true;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
        } else {
          this.$Message.error("手机号格式不正确!");
        }
      } else {
        this.$Message.error("请先填写手机号码!");
      }
    },
    getPhoneCode() {
      this.$axios
        .post("/app/auth/sendSms", {
          phone: this.formData.mobile,
          scene: "register",
        })
        .then((res) => {
          if (res.code == 1) {
            this.$Message.success("发送成功");
          } else {
            this.$Message.error(res.msg);
          }
        });
    },
  },
};
</script>

